import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=a7e8f498&scoped=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"
import style0 from "./AddProduct.vue?vue&type=style&index=0&id=a7e8f498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e8f498",
  null
  
)

export default component.exports